import { cn } from '@crm/ui';
import type { ReactNode } from 'react';

/**
 * Botoes de acao do wizard de cadastro. No celular ficam fixos no rodape,
 * sempre visiveis sem precisar rolar; a partir de `sm:` voltam a fluir
 * normalmente, logo abaixo do formulario. Mesmo padrao em todos os passos
 * (dados, horarios, servicos, landing page). Por padrao o botao fica a
 * direita; passos com Voltar+Avancar usam `justify="between"`.
 */
export function WizardFooter({
  children,
  justify = 'end',
}: {
  children: ReactNode;
  justify?: 'end' | 'between' | 'center';
}) {
  return (
    <div className="fixed inset-x-0 bottom-0 z-10 border-t border-border bg-background/95 px-4 py-3 backdrop-blur sm:static sm:mt-8 sm:border-0 sm:bg-transparent sm:px-0 sm:py-0 sm:backdrop-blur-none sm:[&_button]:h-11">
      <div
        className={cn(
          'mx-auto flex max-w-2xl items-center gap-2',
          justify === 'between' && 'justify-between',
          justify === 'center' && 'justify-center',
          justify === 'end' && 'justify-end',
        )}
      >
        {children}
      </div>
    </div>
  );
}
